import { useEffect } from "react";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftSelect from "components/SoftSelect";
import userInvitePP from "assets/images/crop.jpg";
import ProtectedButton from "authentication/ProtectedButton";
import { PERMISSIONS } from "constants/portal";

function InvitedUsersCard({ users = [], setUserRoles, roles }) {
   const userRole = roles.find((role) => role.name?.toLowerCase() === "user");

   useEffect(() => {
      if (userRole) {
         let uRoles = {};
         users.map(({ email }) => {
            uRoles[email] = userRole.id;
         });
         setUserRoles(uRoles);
      }
   }, [users]);

   const renderProfiles = users.map(({ email }) => (
      <SoftBox key={email} component="li" display="flex" alignItems="center" py={1} mb={1}>
         <SoftBox mr={2}>
            <SoftAvatar src={userInvitePP} alt="something here" variant="rounded" />
         </SoftBox>
         <SoftBox display="flex" flexDirection="column" alignItems="flex-start">
            <SoftTypography variant="caption" color="text">
               {email}
            </SoftTypography>
         </SoftBox>
         <SoftBox ml="auto" width="200px">
            <ProtectedButton permissionName={PERMISSIONS.ASSIGN_ROLE}>
               <SoftSelect
                  placeholder="Select Role"
                  defaultValue={userRole ? { value: userRole.id, label: userRole.name } : { value: "not_fetched", label: "Roles Not Fetched" }}
                  options={[...(roles?.filter((role) => role.name?.toLowerCase() !== "owner").map((role) => ({ value: role.id, label: role.name })) ?? [])]}
                  onChange={(selectedOption) => {
                     setUserRoles((prevRoles) => ({
                        ...prevRoles,
                        [email]: selectedOption.value
                     }));
                  }}
               />
            </ProtectedButton>
         </SoftBox>
      </SoftBox>
   ));

   return (
      <SoftBox p={2}>
         <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            {renderProfiles}
         </SoftBox>
      </SoftBox>
   );
}

InvitedUsersCard.propTypes = {
   users: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default InvitedUsersCard;
